import { useGetClaimStatusProperty } from 'hooks/utils.hook';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { RootState } from 'store/store';
import Typography from 'styles/typography/Typograpy';
import { IClaim } from 'types/Claim';
import { useTranslation } from 'utils/translations';

const ClaimStatusBreadcrumbs = ({ claim }: { claim: IClaim }) => {
	const { t: tDbLabels } = useTranslation('', {
		keyPrefix: 'dbLabels',
	});
	const { t: tClientLabels } = useTranslation('', {
		keyPrefix: 'clientLabels',
	});
	const navigate = useNavigate();

	const { getClaimStatus } = useGetClaimStatusProperty();

	const { features } = useSelector((store: RootState) => store.user);
	const featuresRole = features.map(el => el.code);

	const {
		status: { id },
	} = claim;

	const errorIds = [2, 7, 8, 15];

	return [1, 18].includes(id) && featuresRole.includes('submit-claims') ? (
		<>
			<Typography
				sx={{
					textDecoration: 'underline',
					textUnderlineOffset: '4px',
				}}
				variant="bodyLink"
				onClick={() => {
					navigate(
						`/check-and-submit/${claim.memberFullName}/new-claim?claimUUID=${claim.claimUUID}`,
					);
				}}
			>
				{tDbLabels(getClaimStatus(id)?.label)}
			</Typography>
			{claim.status.reasonCodeLabel && (
				<Typography variant="body" fontWeight={400} paddingLeft={'0.5rem'}>
					{tClientLabels('claim.labels.reasonCode', {
						reasonCode: tDbLabels(claim.status.reasonCodeLabel || ''),
					})}
				</Typography>
			)}
		</>
	) : (
		<Typography variant="bodyLink" color={errorIds.includes(id) ? 'error' : ''}>
			{tDbLabels(getClaimStatus(id)?.label)}{' '}
			{claim.status.reasonCodeLabel && id !== 14 && (
				<Typography variant="body">
					{tClientLabels('claim.labels.reasonCode', {
						reasonCode: tDbLabels(claim.status.reasonCodeLabel || ''),
					})}
				</Typography>
			)}
		</Typography>
	);
};

export default ClaimStatusBreadcrumbs;
